import spiderman from '@/spiderman/index';

const { axios, api } = spiderman;

async function verify({ lineToken, clinic }) {
  return (
    await axios.post(api.auth, {
      lineToken, clinic,
    })
  ).data;
}

export default {
  verify,
};
